import React, {Component} from 'react';
import PropTypes from 'prop-types';
class MovimentiListTypeButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let classNameLista = "ui " + (this.props.listType === 'l' ? "positive" : "") + " button"
        let classNameReport = "ui " + (this.props.listType === 'r' ? "positive" : "") + " button"

        return (
        <div className="ui buttons">
            <button className={classNameLista} onClick={() => this.props.onButtonClick('l')}>Lista</button>
            <div className="or" data-text="o"></div>
            <button className={classNameReport} onClick={() => this.props.onButtonClick('r')}>Report</button>
        </div>
        )
    }
}
MovimentiListTypeButton.PropTypes = {
    listType: PropTypes.oneOf(['l', 's']).isRequired, // l: List r:Report
    iconSize: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired // argomento:  listType: l/r
}

MovimentiListTypeButton.defaultProps = {
    iconSize: ""
};

export default MovimentiListTypeButton;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiListTypeButton.jsx
 **/